import {
    GET_JOB_SITES,
    GET_JOB_SITES_SUCCESS,
    GET_JOB_SITES_FAILURE,
    SET_LANGUAGE,
    INITIALIZE_LANGUAGE,
    SIGNATURE,
    SIGNATURE_SUCCESS,
    SIGNATURE_FAILURE,
    GET_VIDEO,
    GET_VIDEO_SUCCESS,
    GET_VIDEO_FAILURE,
    SIGNATURE_STATUS,
    SIGNATURE_STATUS_SUCCESS,
    SIGNATURE_STATUS_FAILURE,
  } from "./types"
  
  export const getJobSites = data => ({
    type: GET_JOB_SITES,
    data
  })
  
  export const getJobSitesSuccess = data => ({
    type: GET_JOB_SITES_SUCCESS,
    data
  })
  
  export const getJobSitesFailure = error => ({
    type: GET_JOB_SITES_FAILURE,
    error
  })
  
  // Action to initialize language
  export const initializeLanguage = () => ({
    type: INITIALIZE_LANGUAGE,
  });
  
  // Action to set language manually
  export const setLanguage = (language) => ({
    type: SET_LANGUAGE,
    language,
  });

  export const signature = (data, id,meeting_id) => ({
    type: SIGNATURE,
    data,
    id,
    meeting_id
  })
  
  export const checkSignatureStatus = (id,meeting_id) => ({
    type: SIGNATURE_STATUS,
    id,
    meeting_id
  })
  
  export const checkSignatureStatusSuccess = (data, id) => ({
    type: SIGNATURE_STATUS_SUCCESS,
    data,
    id
  })
  
  export const checkSignatureStatusFailure = (error) => ({
    type: SIGNATURE_STATUS_FAILURE,
    error
  })
  
  export const signatureSuccess = (data, id) => ({
    type: SIGNATURE_SUCCESS,
    data,
    id
  })
  
  export const signatureFailure = error => ({
    type: SIGNATURE_FAILURE,
    error
  })
  
  export const getVideo = data => ({
    type: GET_VIDEO,
    data
  })
  
  export const getVideoSuccess = data => ({
    type: GET_VIDEO_SUCCESS,
    data
  })
  
  export const getVideoFailure = error => ({
    type: GET_VIDEO_FAILURE,
    error
  })